import parseHTML from "../lib/dom/funciones/parse_html";
var galeria = function () {
    Array.from(document.querySelectorAll('.bloque--galeria')).forEach(function (galeria) {
        var lista = galeria.querySelector('.galeria__lista');
        if (!lista) {
            return;
        }
        var navegacion = parseHTML('<div class="slider__botones animado"></div>');
        var bolas = [];
        var ajustaBolas = function () {
            var paginas = Math.ceil(lista.scrollWidth / lista.offsetWidth);
            if (paginas <= 1) {
                navegacion.remove();
                return;
            }
            navegacion.innerHTML = '';
            var _loop_1 = function (i) {
                var bola = parseHTML('<button class="slider__boton"></button>');
                bola.addEventListener('click', function () {
                    bolas.forEach(function (b) { return b.classList.remove('galeria__bola--activo'); });
                    lista.scrollTo({
                        left: i * lista.offsetWidth,
                        behavior: 'smooth'
                    });
                });
                navegacion.appendChild(bola);
            };
            for (var i = 0; i < paginas; i++) {
                _loop_1(i);
            }
            bolas = Array.from(navegacion.querySelectorAll('.slider__boton'));
            galeria.appendChild(navegacion);
            actualizaActivo();
        };
        var actualizaActivo = function () {
            var scroll = lista.scrollLeft;
            var ancho = lista.scrollWidth;
            var paginaActual;
            if (scroll === lista.scrollWidth - lista.offsetWidth) {
                paginaActual = bolas.length - 1;
            }
            else {
                paginaActual = Math.round(scroll * bolas.length / ancho);
            }
            bolas.forEach(function (bola, i) {
                bola.setAttribute('aria-selected', i === paginaActual ? 'true' : 'false');
            });
        };
        lista.addEventListener('scroll', actualizaActivo);
        addEventListener('resize', ajustaBolas);
        ajustaBolas();
    });
};
export var fotos = function (selector) {
    if (selector === void 0) { selector = '.bloque--galeria'; }
    var galerias = Array.from(document.querySelectorAll(selector));
    if (galerias.length === 0) {
        return;
    }
    var ventanaGrande = parseHTML("\n        <div class=\"foto__grande\" inert>\n            <div class=\"foto__grande__cerrar\">\n                <button>\n                    <svg width=\"37\" height=\"36\" viewBox=\"0 0 37 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <title>Close</title>\n                        <path d=\"M33.5263 0.292856C33.9167 -0.097596 34.5498 -0.0974521 34.9403 0.292856C35.3309 0.683381 35.3309 1.31639 34.9403 1.70692L19.7372 16.9091L36.3554 33.5272C36.7455 33.9178 36.7457 34.5509 36.3554 34.9413C35.9649 35.3318 35.3309 35.3318 34.9403 34.9413L18.3231 18.3241L1.70694 34.9413C1.3165 35.3317 0.683408 35.3315 0.292874 34.9413C-0.0976374 34.5508 -0.0976121 33.9178 0.292874 33.5272L16.9091 16.9091L1.70694 1.70692C1.31641 1.31639 1.31641 0.683381 1.70694 0.292856C2.09747 -0.0975941 2.7305 -0.0976434 3.121 0.292856L18.3231 15.495L33.5263 0.292856Z\" fill=\"#1E1E1C\"/>\n                    </svg>\n                </button>\n            </div>\n            <div class=\"foto__grande__imagen\">\n            </div>\n            <div class=\"foto__grande__navegacion\">\n                <div class=\"foto__grande__anterior\">\n                    <button>Siguiente</button>\n                </div>\n                <div class=\"foto__grande__siguiente\">\n                    <button>Anterior</button>\n                </div>\n            </div>\n        </div>\n");
    var listaAbierta;
    var cerrarVentana = function () { return ventanaGrande.inert = true; };
    var navegacion = ventanaGrande.querySelector('.foto__grande__navegacion');
    var anterior = ventanaGrande.querySelector('.foto__grande__anterior');
    var siguiente = ventanaGrande.querySelector('.foto__grande__siguiente');
    var cerrar = ventanaGrande.querySelector('.foto__grande__cerrar button');
    var imagenGrande = ventanaGrande.querySelector('.foto__grande__imagen');
    var paraVideoSiExiste = function (contenedor) {
        var video = contenedor.querySelector('video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    };
    var arrancaVideoSiExiste = function (contenedor) {
        var video = contenedor.querySelector('video');
        if (video) {
            video.addEventListener('loadeddata', function () {
                video.classList.add(video.videoWidth > video.videoHeight ? 'foto__video--horizontal' : 'foto__video--vertical');
            });
            video.play();
        }
    };
    var muestraFoto = function (index) {
        paraVideoSiExiste(imagenGrande);
        abierto = index;
        imagenGrande.innerHTML = listaAbierta[index].dataset.imagen || '';
        ventanaGrande.inert = false;
        arrancaVideoSiExiste(imagenGrande);
    };
    var abierto = -1;
    var desplaza = function (direccion) { return function () {
        abierto += direccion;
        if (abierto < 0) {
            abierto = listaAbierta.length - 1;
        }
        else if (abierto >= listaAbierta.length) {
            abierto = 0;
        }
        muestraFoto(abierto);
    }; };
    cerrar.addEventListener('click', cerrarVentana);
    anterior.addEventListener('click', desplaza(-1));
    siguiente.addEventListener('click', desplaza(1));
    addEventListener('keydown', function (e) {
        if (ventanaGrande.inert) {
            return;
        }
        if (e.key === 'Escape') {
            cerrarVentana();
        }
        else if (e.key === 'ArrowLeft') {
            anterior.click();
        }
        else if (e.key === 'ArrowRight') {
            siguiente.click();
        }
    });
    document.body.appendChild(ventanaGrande);
    galerias.forEach(function (galeria) {
        var links = Array.from(galeria.querySelectorAll('a'));
        links.forEach(function (link) {
            link.addEventListener('click', function (e) {
                listaAbierta = links;
                if (links.length < 2) {
                    navegacion.remove();
                }
                else {
                    ventanaGrande.appendChild(navegacion);
                }
                e.preventDefault();
                muestraFoto(listaAbierta.indexOf(link));
            });
        });
    });
};
export default (function () {
    galeria();
    fotos();
});
